import { Directive, computed, inject } from '@angular/core'
import { BrnAvatarFallback } from '@spartan-ng/brain/avatar'
import { hlm } from '@spartan-ng/helm/utils'

@Directive({
  selector: '[hlmAvatarFallback]',
  exportAs: 'avatarFallback',
  hostDirectives: [BrnAvatarFallback],
  host: {
    '[class]': '_computedClass()'
  }
})
export class HlmAvatarFallback {
  protected readonly _computedClass = computed(() =>
    hlm('bg-muted flex size-full items-center justify-center rounded-full')
  )
}
